import BaseAssessmentController from '../base-assessment.controller';
import * as DisclosureType from '../../constants/disclosureType';

class ConflictOfInterestAssessmentController extends BaseAssessmentController {
    constructor(preFetchedData, componentRegistryService, componentDataService, disclosureService, loggerService, $state, $q, constants, assessmentService, _, fileSaver) {     
        super('ConflictOfInterestAssessmentController', DisclosureType.Conflict, disclosureService, _, preFetchedData, $q, $state, componentRegistryService, componentDataService, assessmentService, fileSaver, loggerService);
        this.conflictCategories = preFetchedData.conflictCategories;
        this.managementStrategies = this._.filter(preFetchedData.managementStrategies, (cat) => cat.type !== "Gift");
        this.alternativeOfficer = preFetchedData.alternativeOfficer;
        this.hasAlternativeOfficer = preFetchedData.alternativeOfficer && !this._.isEmpty(preFetchedData.alternativeOfficer.fullName);  
        this.conflictStatus = preFetchedData.disclosureData.status;
        this.baseAcknowledgement = [constants.AssessmentAcknowledgements.Base];
        this.ackStrategy = this._.concat(this.baseAcknowledgement, [constants.AssessmentAcknowledgements.ManagementStrategyRequired]); 
        this.ackNoStrategy = this._.concat(this.baseAcknowledgement, [constants.AssessmentAcknowledgements.ManagementStrategyNotRequired]);
        this.managementStrategyRequired = true;
    }

    showManagementStrateyRequiredAcknowledgements(dislosureStatus, managementStrategyRequired, showAcknowledgementsSection = this.showAcknowledgementsSection) {
        return dislosureStatus === 'PendingAssessment' && managementStrategyRequired && showAcknowledgementsSection;
    }

    showManagmentStrategyNotRequiredAcknowledgements(dislosureStatus, managementStrategyRequired, showAcknowledgementsSection = this.showAcknowledgementsSection) {
        return dislosureStatus === 'PendingAssessment' && !managementStrategyRequired && showAcknowledgementsSection;
    }

    onManagementStrategyRequired(managementStrategyRequired) {
        this.showReturnDisclosureInput = this.showReturnCommentsInput(managementStrategyRequired);
        this.managementStrategyRequired = managementStrategyRequired;
        super.toggleAcknowledgements(managementStrategyRequired, this.disclosureData.type);
    }

    isProgressingAssessment() {
        let managementStrategy = this.componentRegistryService.get("managementStrategy");
        let selectedOption  = this._.get(managementStrategy, "model.selectedOption");
        let managementStrategyText = this._.get(managementStrategy, "model.managementStrategyRequired");
        return (selectedOption !== null && selectedOption !== undefined) || 
               (managementStrategyText !== null && managementStrategyText !== undefined);
    }
}

ConflictOfInterestAssessmentController.$inject = ['preFetchedData', 'componentRegistryService', 'componentDataService', 'disclosureService', 'loggerService', '$state', '$q', 'constants', 'assessmentService', '_', 'FileSaver'];

export default ConflictOfInterestAssessmentController;


// WEBPACK FOOTER //
// ./app/assess/conflictOfInterest/conflictOfInterestAssessment.controller.js